/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select, DatePicker } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	GENERIC_LOOKUP, OCCUPATION_CODE, INDUSTRY_CODE,
	CLASS_WORKER, NATURE_EMPLOYMENT, REASON_NOT_APPLYING_JOB
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator, getFieldValue } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={4} sm={24}>
						<Form.Item label='OFW'>
							{ getFieldDecorator('ofw', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Employed'>
							{ getFieldDecorator('employed', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='With Business?'>
							{ getFieldDecorator('with_business', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Occupation Code'>
							{ getFieldDecorator('occupation_code', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Occupation'>
									{
										OCCUPATION_CODE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Other Occupation'>
							{ getFieldDecorator('occupation_others', {
								rules: [{
									required: (getFieldValue('occupation_code') && 
										_.isEqual(getFieldValue('occupation_code'), 'Others (specify)')),
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter other occupation' 
									disabled={!(getFieldValue('occupation_code') && 
										_.isEqual(getFieldValue('occupation_code'), 'Others (specify)'))}
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Industrial Code'>
							{ getFieldDecorator('industry_code', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Industry'>
									{
										INDUSTRY_CODE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Class of Worker'>
							{ getFieldDecorator('class_of_worker', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Class of Work'>
									{
										CLASS_WORKER.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Nature of Employment'>
							{ getFieldDecorator('nature_of_employment', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Nature of Employment'>
									{
										NATURE_EMPLOYMENT.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Activity/occupation during past 3 months'>
							{ getFieldDecorator('activity_past_3mos', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter activity/occupation during past 3 months'
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Province/City/Municipality did work past 3 months'>
							{ getFieldDecorator('where_work_past_3mos', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									placeholder='Enter Province/City/Municipality did work past 3 months'
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Total Salary (peso)'>
							{ getFieldDecorator('total_salary_peso', {
								initialValue: 0,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Input type='number' />
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Total Salary (goods)'>
							{ getFieldDecorator('total_salary_goods', {
								initialValue: 0,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Input type='number' />
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Looking for Job'>
							{ getFieldDecorator('looking_for_job', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={12} sm={24}>
						<Form.Item label='Reason not looking job'>
							{ getFieldDecorator('reason_not_looking_job', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Reason why not applying job'>
									{
										REASON_NOT_APPLYING_JOB.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
